import { TLocaleCode } from 'constants/locales'

export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>

export type Strapi_PageEntityResponseCollection = {
  data: Array<Strapi_PageEntity>
}
export type Strapi_UniquePageEntityResponseCollection = {
  data: Array<Strapi_UniquePageEntity>
}
export type Strapi_PageEntity = {
  id?: Maybe<Scalars['ID']>
  attributes?: Maybe<Strapi_Page>
}
export type Strapi_UniquePageEntity = {
  id?: Maybe<Scalars['ID']>
  attributes?: Maybe<Strapi_UniquePage>
}

export type Scalars = {
  /** The `ID` scalar type represents a unique identifier, often used to refetch an object or as key for a cache. The ID type appears in a JSON response as a String; however, it is not intended to be human-readable. When expected as an input type, any string (such as `"4"`) or integer (such as `4`) input value will be accepted as an ID. */
  ID: string
  /** The `String` scalar type represents textual data, represented as UTF-8 character sequences. The String type is most often used by GraphQL to represent free-form human-readable text. */
  String: string
  /** The `Boolean` scalar type represents `true` or `false`. */
  Boolean: boolean
  /** The `Int` scalar type represents non-fractional signed whole numeric values. Int can represent values between -(2^31) and 2^31 - 1. */
  Int: number
  /** The `Float` scalar type represents signed double-precision fractional values as specified by [IEEE 754](https://en.wikipedia.org/wiki/IEEE_floating_point). */
  Float: number
  /** A date string, such as 2007-12-03, compliant with the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: any
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  STRAPI_JSON: any
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  STRAPI_DateTime: any
  /** The `Upload` scalar type represents a file upload. */
  STRAPI_Upload: any
  /** A string used to identify an i18n locale */
  STRAPI_I18NLocaleCode: any
}

export type Strapi_PageRelationResponseCollection = {
  data: Array<Strapi_PageEntity>
}

export type Strapi_Page = {
  title: Scalars['String']
  content: Scalars['String']
  url: Scalars['String']
  subcategory: Scalars['String']
  youTubeVideoId?: Maybe<Scalars['String']>
  youTubeVideoTitle?: Maybe<Scalars['String']>
  createdAt?: Maybe<Scalars['STRAPI_DateTime']>
  updatedAt?: Maybe<Scalars['STRAPI_DateTime']>
  publishedAt?: Maybe<Scalars['STRAPI_DateTime']>
  locale?: Maybe<Scalars['String']>
  localizations?: Maybe<Strapi_PageRelationResponseCollection>
  sidebar: Maybe<SideBar>
  seo: any
}

export type SideBar = {
  data: {
    attributes: {
      name: string
    }
  }
}

export type Strapi_UniquePage = {
  locale?: Maybe<Scalars['String']>
  Title?: Maybe<TUniqTitle>
  JSON: any
  seo: any
}

export type Strapi_I18NLocale = {
  name?: Maybe<Scalars['String']>
  code?: Maybe<Scalars['String']>
  createdAt?: Maybe<Scalars['STRAPI_DateTime']>
  updatedAt?: Maybe<Scalars['STRAPI_DateTime']>
}

export type Strapi_I18NLocaleEntity = {
  id?: Maybe<Scalars['ID']>
  attributes?: Maybe<Strapi_I18NLocale>
}

export type Strapi_I18NLocaleEntityResponseCollection = {
  data: Array<Strapi_I18NLocaleEntity>
}

export type Strapi_NavbarEntity = {
  data: Array<{ id?: Maybe<Scalars['ID']>; attributes?: Maybe<Strapi_Navbar> }>
}

export type Strapi_Navbar = {
  name: Scalars['String']
  dropdown?: Maybe<Scalars['Boolean']>
  warning?: Maybe<Scalars['String']>
  navbarLinks?: Maybe<Strapi_NavbarLinkRelationResponseCollection>
  order: Scalars['Int']
  createdAt?: Maybe<Scalars['STRAPI_DateTime']>
  updatedAt?: Maybe<Scalars['STRAPI_DateTime']>
  publishedAt?: Maybe<Scalars['STRAPI_DateTime']>
  localizations?: Maybe<any>
  locale?: Maybe<Scalars['String']>
  withLocale?: boolean
  badgeType?: BadgeType
}

export type Strapi_NavbarLinkRelationResponseCollection = {
  data: Array<Strapi_NavbarLinkEntity>
}

export type Strapi_NavbarLinkEntity = {
  id?: Maybe<Scalars['ID']>
  attributes?: Maybe<Strapi_NavbarLink>
}

export type Strapi_NavbarLink = {
  name: Scalars['String']
  url: Scalars['String']
  warning?: Maybe<Scalars['String']>
  navbar?: Maybe<any>
  createdAt?: Maybe<Scalars['STRAPI_DateTime']>
  updatedAt?: Maybe<Scalars['STRAPI_DateTime']>
  publishedAt?: Maybe<Scalars['STRAPI_DateTime']>
  localizations?: Maybe<Strapi_NavbarLinkRelationResponseCollection>
  locale?: Maybe<Scalars['String']>
  badgeType?: BadgeType
  urlEn?: string
  includeLangsArr?: TLocaleCode[]
  component?: () => JSX.Element
  showChat?: (id: boolean) => void
}

export type Pair = {
  name: string
  asset: string
  label: string
  swapBuy: number
  minStep: number
  takerFee: number
  swapSell: number
  globalId: number
  makerFee: number
  precision: number
  avaliable: boolean
  bonusActive: boolean
  leverageStep: number
  leverageMaxValue: number
  leverageMinValue: number
  hide: boolean
}

export interface ICollateral {
  id: number
  asset: string
  name: string
  multiplier: number
  active: boolean
  withdrawalCommission: number
  withdrawalMinSum: number
  bonusAmount: number
  bonusStatus: number
  system: boolean
  crossMarginLeverage: number
  crossMarginAvailable: number
  stopOutLevel: number
  fullName: string
}

export type Collaterals = Array<ICollateral>

export type Pairs = Pair[]

export interface Candle {
  time: number
  low: number
  high: number
  open: number
  close: number
  volume: number
}

export interface CandleWithGlobalId extends Candle {
  globalId: number
  label: string
}

export type Candles = {
  [key: number]: CandleWithGlobalId
}

export type PairFormatted = {
  isPositive: boolean
  Icon: (props: React.SVGProps<SVGSVGElement>) => JSX.Element
  percent: string
  price: string
  label: string
}

export type PairItemTypes = {
  isPositive: boolean
  coinsRequestName?: string
  tickerLabel?: string
  percent: string
  estimatedAmount?: string
  label: string
  trendRange: '24H' | string
  isBadge: BadgeType | null
  isIndicator: boolean
  isError?: string
  price?: string
}

export type PairsFormatted = Array<PairFormatted>

export type ChartData = Array<{ name: string; value: number }>

export type PairsChartsData = {
  [key: string]: Array<Candle>
}

export interface CandleData {
  count: number
  data: Array<Candle>
}

export interface CandleResponse {
  t: number
  l: number
  h: number
  o: number
  c: number
  v: number
}

export interface CandleDataResponse {
  count: number
  data: Array<CandleResponse>
}

export interface ICandlesWithPairId {
  data: Candle[]
  globalId: number
}

export type CandlesData = Array<CandleData>

export type FormattedCandles = {
  [key: string]: Array<number>
}

export type FooterAndPrivacyLinksQuery = {
  footers?: {
    data: Array<{
      id?: string | null
      attributes?: {
        locale?: string | null
        name: string
        footerLinks?: {
          data: Array<{
            id?: string | null
            attributes?: { url: string; warning?: string | null; name: string } | null
          }>
        } | null
      } | null
    }>
  } | null
  footerPrivacyLinks?: {
    data: Array<{ id?: string | null; attributes?: { locale?: string | null; url: string; name: string } | null }>
  } | null
}

export type FooterQuery = {
  data: Array<{
    id?: string | null
    attributes?: {
      locale?: string | null
      name: string
      footerLinks?: {
        data: Array<{
          id?: string | null
          attributes?: { url: string; warning?: string | null; name: string } | null
        }>
      } | null
    } | null
  }>
} | null

export type FooterPrivacyLinksQuery = {
  data: Array<{ id?: string | null; attributes?: { locale?: string | null; url: string; name: string } | null }> | null
}

export interface IPageCreateResponse {
  strapi: {
    pages?: Maybe<Strapi_PageEntityResponseCollection>
    uniquePages?: Maybe<Strapi_UniquePageEntityResponseCollection>
    navbars: Maybe<Strapi_NavbarEntity>
    dropdowns: any
    footers: FooterQuery
    footerPrivacyLinks: FooterPrivacyLinksQuery
  }
}

export type TUniqTitle =
  | 'MainPage'
  | 'CryptoFeatureTraiding'
  | 'LandingAppPage'
  | 'AboutUs'
  | 'Careers'
  | 'ContactUs'
  | 'PlatformsSecurity'
  | 'Referral'
  | 'CrossMarginVersusIsolatedMargin'
  | 'CookiePolicy'
  | 'PrivacyPolicy'
  | 'TermsAndConditions'
  | 'TermsAndConditionsReferral'
  | 'TermsAndStaking'
  | 'CopyTradingTerms'
  | 'footerWarning'
  | 'General'
  | 'CryptoAlerts'
  | 'HowToShortCrypto'
  | 'CryptoMarginTrading'
  | 'Staking'
  | 'BuyCrypto'
  | 'AmlPolicy'
  | 'Copytrading'
  | 'EmptyHeaderPage'

export type DropdownType =
  | 'app'
  | 'buy crypto'
  | 'futures'
  | 'spot'
  | 'explore trading'
  | 'price alerts'
  | 'staking'
  | 'markets'
  | 'refferal'
  | 'mobile'
  | 'copy trading'

export enum BadgeType {
  New = 'New',
  Copy = 'new',
  Tiket = 'Copy',
  Hot = 'Hot',
  Popular = 'Popular',
  Soon = 'Soon',
  Bonus = 'Bonus',
  Promo = 'Promo',
  BestOffer = 'Best offer',
  InDevelopment = 'In development',
  Leaern = 'Learn',
  Download = 'Download',
}
